// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WeeklyreportprojectName{
    font-family: "Inter";
font-size: 18px;
font-weight: 600;
line-height: 21.78px;
letter-spacing: 0.02em;
text-align: left;
color:#00B562
}
.WeeklyReport1stheading{
    font-family: "Inter";
font-size: 18px;
font-weight: 700;
line-height: 21.78px;
letter-spacing: 0.02em;
text-align: left;
color:#0070E9;
}


.wr-first3-headings{
    font-family: "Inter";
font-size: 14px;
font-weight: 700;
line-height: 16.94px;
letter-spacing: 0.02em;
text-align: center;
color: #0070E9;


}
.wr-week-heading{
    font-family: "Inter";
font-size: 14px;
font-weight: 500;
line-height: 16.94px;
letter-spacing: 0.02em;
text-align: center;
color:#00162E;
height: 42px;

}
.wr-first3colsin-body{
    font-family: "Inter";
font-size: 15px;
font-weight: 700;
line-height: 16.94px;
letter-spacing: 0.02em;
color:#375370


}
.wr-tasks{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    color: black;
    height:40px
}
.wr-Pto{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    color: #0070E9;
    height:40px
    
    
}
.wr-sickleave{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    height:40px;
    color: #E97000;


}
.wr-th-toprow{
    font-family: "Inter";
    font-size: 13px;
    font-weight: 700;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    background-color: #E5F0FC;
    color: #002C5D;
    text-align: left;
    padding-left: 10px;
    /* width:100%; */
    height:28px;
    white-space: nowrap;
}
.wr-th-botrow{
    font-family: "Inter";
    font-size: 13px;
    font-weight: 700;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    padding-left: 10px;
    background-color: #E7F8F0 !important;
    color: #002C5D;
    text-align: left;
    height:28px;
    white-space: nowrap;


}
.sick-task {
    color: #E97000;
    font-family: "Inter";
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    height:40px;
  }
  
  .pto-task {
    color: #0070E9;
    font-family: "Inter";
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    height:40px;
  }
  
  .default-task {
    color: black;
  }

  /* 6/7/2024 */

  .ExportButtoninWeeklyReports{
     background-color: #FE602F !important;
     color: white !important;
     height:45px !important;
     width: 90px !important;


  }

`, "",{"version":3,"sources":["webpack://./src/views/panel/reports/Weeklreport/WeeklyReports.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB;AACA;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB,aAAa;AACb;;;AAGA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,kBAAkB;AAClB,cAAc;;;AAGd;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,kBAAkB;AAClB,aAAa;AACb,YAAY;;AAEZ;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB;;;AAGA;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,YAAY;IACZ;AACJ;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,cAAc;IACd;;;AAGJ;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;IACX,cAAc;;;AAGlB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,mBAAmB;;;AAGvB;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA,aAAa;;EAEb;KACG,oCAAoC;KACpC,uBAAuB;KACvB,sBAAsB;KACtB,sBAAsB;;;EAGzB","sourcesContent":[".WeeklyreportprojectName{\r\n    font-family: \"Inter\";\r\nfont-size: 18px;\r\nfont-weight: 600;\r\nline-height: 21.78px;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\ncolor:#00B562\r\n}\r\n.WeeklyReport1stheading{\r\n    font-family: \"Inter\";\r\nfont-size: 18px;\r\nfont-weight: 700;\r\nline-height: 21.78px;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\ncolor:#0070E9;\r\n}\r\n\r\n\r\n.wr-first3-headings{\r\n    font-family: \"Inter\";\r\nfont-size: 14px;\r\nfont-weight: 700;\r\nline-height: 16.94px;\r\nletter-spacing: 0.02em;\r\ntext-align: center;\r\ncolor: #0070E9;\r\n\r\n\r\n}\r\n.wr-week-heading{\r\n    font-family: \"Inter\";\r\nfont-size: 14px;\r\nfont-weight: 500;\r\nline-height: 16.94px;\r\nletter-spacing: 0.02em;\r\ntext-align: center;\r\ncolor:#00162E;\r\nheight: 42px;\r\n\r\n}\r\n.wr-first3colsin-body{\r\n    font-family: \"Inter\";\r\nfont-size: 15px;\r\nfont-weight: 700;\r\nline-height: 16.94px;\r\nletter-spacing: 0.02em;\r\ncolor:#375370\r\n\r\n\r\n}\r\n.wr-tasks{\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    color: black;\r\n    height:40px\r\n}\r\n.wr-Pto{\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    color: #0070E9;\r\n    height:40px\r\n    \r\n    \r\n}\r\n.wr-sickleave{\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    height:40px;\r\n    color: #E97000;\r\n\r\n\r\n}\r\n.wr-th-toprow{\r\n    font-family: \"Inter\";\r\n    font-size: 13px;\r\n    font-weight: 700;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    background-color: #E5F0FC;\r\n    color: #002C5D;\r\n    text-align: left;\r\n    padding-left: 10px;\r\n    /* width:100%; */\r\n    height:28px;\r\n    white-space: nowrap;\r\n}\r\n.wr-th-botrow{\r\n    font-family: \"Inter\";\r\n    font-size: 13px;\r\n    font-weight: 700;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    padding-left: 10px;\r\n    background-color: #E7F8F0 !important;\r\n    color: #002C5D;\r\n    text-align: left;\r\n    height:28px;\r\n    white-space: nowrap;\r\n\r\n\r\n}\r\n.sick-task {\r\n    color: #E97000;\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    height:40px;\r\n  }\r\n  \r\n  .pto-task {\r\n    color: #0070E9;\r\n    font-family: \"Inter\";\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 16.94px;\r\n    letter-spacing: 0.02em;\r\n    height:40px;\r\n  }\r\n  \r\n  .default-task {\r\n    color: black;\r\n  }\r\n\r\n  /* 6/7/2024 */\r\n\r\n  .ExportButtoninWeeklyReports{\r\n     background-color: #FE602F !important;\r\n     color: white !important;\r\n     height:45px !important;\r\n     width: 90px !important;\r\n\r\n\r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
